// /src/pages/Home/introTour.js
import introJs from "intro.js";
import "intro.js/introjs.css";

export const HOME_TOUR_KEY = "homeTourCompleted";

/**
 * Run the home page intro tour.
 * Assumes all required DOM elements and CSS classes already exist.
 */
export const runHomeIntroTour = (menuItemsStrings) => {
  const tour = introJs();

  tour.setOptions({
    steps: [
      {
        element: ".tour-homepage-page",
        intro: menuItemsStrings.tourHomePage,
        title: menuItemsStrings.tourHomePageTitle,
        highlightClass: "custom-highlight-mod-position",
      },
      {
        element: ".tour-global-sidebar",
        intro: menuItemsStrings.tourGlobalNavbar,
        title: menuItemsStrings.tourGlobalNavbarTitle,
      },
      {
        element: ".tour-global-navbar-homePage",
        intro: menuItemsStrings.tourGlobalNavbarHomePage,
        title: menuItemsStrings.tourGlobalNavbarHomePageTitle,
      },
      {
        element: ".tour-global-navbar-completedRoutes",
        intro: menuItemsStrings.tourGlobalNavbarCompletedRoutes,
        title: menuItemsStrings.tourGlobalNavbarCompletedRoutesTitle,
      },
      {
        element: ".tour-global-navbar-licensing",
        intro: menuItemsStrings.tourGlobalNavbarLicensing,
        title: menuItemsStrings.tourGlobalNavbarLicensingTitle,
      },
      {
        element: ".tour-global-current-selections",
        intro: menuItemsStrings.tourGlobalCurrentSelections,
        title: menuItemsStrings.tourGlobalCurrentSelectionsTitle,
      },
      {
        element: ".tour-global-current-selections-front-buttons",
        intro: menuItemsStrings.tourGlobalCurrentSelectionsNavigationButtons,
        title:
          menuItemsStrings.tourGlobalCurrentSelectionsNavigationButtonsTitle,
      },
      {
        element: ".tour-global-current-selections-active-selections",
        intro: menuItemsStrings.tourGlobalCurrentSelectionsActiveFilters,
        title: menuItemsStrings.tourGlobalCurrentSelectionsActiveFiltersTitle,
      },
      {
        element: ".tour-global-filterpane-dropdown",
        intro: menuItemsStrings.tourGlobalAllFilters,
        title: menuItemsStrings.tourGlobalAllFiltersTitle,
      },
      {
        element: ".tour-home-kpi-row",
        intro: menuItemsStrings.tourHomeKPIRow,
        title: menuItemsStrings.tourHomeKPIRowTitle,
        tooltipClass: "custom-tooltip-tour-home-kpi-row",
        highlightClass: "custom-highlight-mod-position",
      },
      {
        element: ".tour-home-kpi-no-of-routes-switch",
        intro: menuItemsStrings.tourHomeKPISingleNoOfRoutesSwitch,
        title: menuItemsStrings.tourHomeKPISingleNoOfRoutesSwitchTitle,
        tooltipClass: "custom-tooltip-tour-home-kpi-no-of-routes",
        highlightClass: "custom-highlight-mod-position",
      },
      {
        element: ".tour-home-kpi-no-of-flights",
        intro: menuItemsStrings.tourHomeKPISingleNoOfFlights,
        title: menuItemsStrings.tourHomeKPISingleNoOfFlightsTitle,
        tooltipClass: "custom-tooltip-tour-home-kpi-no-of-flights",
        highlightClass: "custom-highlight-mod-position",
      },
      {
        element: ".tour-home-kpi-no-of-flights-switch",
        intro: menuItemsStrings.tourHomeKPISingleNoOfFlightsSwitch,
        title: menuItemsStrings.tourHomeKPISingleNoOfFlightsSwitchTitle,
        tooltipClass: "custom-tooltip-tour-home-kpi-no-of-flights",
        highlightClass: "custom-highlight-mod-position",
      },
      {
        element: ".tour-home-barchart",
        intro: menuItemsStrings.tourHomeBarchart,
        title: menuItemsStrings.tourHomeBarchartTitle,
        highlightClass: "custom-highlight-mod-position",
      },
      {
        element: ".tour-home-container",
        intro: menuItemsStrings.tourHomeContainer,
        title: menuItemsStrings.tourHomeContainerTitle,
        highlightClass: "custom-highlight-mod-position",
      },
      {
        element: ".tour-home-barchart-kpi-selection",
        intro: menuItemsStrings.tourHomeBarchartSelection,
        title: menuItemsStrings.tourHomeBarchartSelectionTitle,
        keyboardNavigation: false,
        tooltipClass: "custom-tooltip-tour-home-barchart-kpi-selection",
        highlightClass: "custom-highlight-mod-position",
      },
    ],
    showBullets: true,
    showStepNumbers: true,
    nextLabel: menuItemsStrings.tourParamsNext,
    prevLabel: menuItemsStrings.tourParamsPrev,
    doneLabel: menuItemsStrings.tourParamsDone,
    stepNumbersOfLabel: menuItemsStrings.tourParamsOf,
    helperElementPadding: 0,
    dontShowAgain: false,
    autoPosition: true,
    scrollToElement: true,
  });

  tour.oncomplete(() => {
    console.log("Home tour completed, saving to localStorage");
    localStorage.setItem(HOME_TOUR_KEY, "true");
  });

  tour.onexit(() => {
    console.log("Home tour exited, saving to localStorage");
    localStorage.setItem(HOME_TOUR_KEY, "true");
  });

  tour.start();
};
